import React from 'react'

import Stepper from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { useTranslation } from 'react-i18next'
import { isWebView } from '../../../../../../../utils/navigation'

const NoBedrooms: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => {
  const { t } = useTranslation()

  const isMobileView = isWebView()

  return (
    <Stepper
      id='no-bedrooms'
      propertyName='noBedrooms'
      label='wizard.screen.otherFacilities.noBedrooms'
      placeholder={isMobileView ? t('wizard.screen.objectDetails.placeholder.amount') : ''}
      input={insertionData.noBedrooms}
      type='tel'
      maxLength={3}
      max={99}
      errors={validationMessages!.noBedrooms ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  )
}

export default NoBedrooms
